import { useMemo, useState } from "react";

export default function QuickActionDocumentModal({
  open,
  loading,
  workorders,
  onClose,
  onSubmit,
}) {
  const [workorderId, setWorkorderId] = useState("");
  const [file, setFile] = useState(null);

  const options = useMemo(() => workorders || [], [workorders]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit({ workorderId, file });
    setWorkorderId("");
    setFile(null);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">Document uploaden</h3>

        <form onSubmit={handleSubmit} className="mt-4 space-y-3">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Werkbon</label>
            <select
              value={workorderId}
              onChange={(event) => setWorkorderId(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
              required
            >
              <option value="">Kies werkbon</option>
              {options.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.werkbonnummer} - {item.titel}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Bestand</label>
            <input
              type="file"
              onChange={(event) => setFile(event.target.files?.[0] || null)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2"
              required
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm" disabled={loading}>
              Annuleren
            </button>
            <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white" disabled={loading || !file}>
              {loading ? "Uploaden..." : "Uploaden"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
